/**
 * Client (Healthcare Organization) API Service
 */

import apiClient from './apiClient';
import {
  ClientDTO,
  CreateClientRequest,
  PageResponse,
} from '../types/client.types';

const BASE_PATH = '/v1/clients';

class ClientService {
  async createClient(request: CreateClientRequest): Promise<ClientDTO> {
    const response = await apiClient.post<ClientDTO>(BASE_PATH, request);
    return response.data;
  }

  async getClientById(id: string): Promise<ClientDTO> {
    const response = await apiClient.get<ClientDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  }

  async getClientByCode(code: string): Promise<ClientDTO> {
    const response = await apiClient.get<ClientDTO>(`${BASE_PATH}/code/${code}`);
    return response.data;
  }

  async getAllClients(page: number = 0, size: number = 20): Promise<PageResponse<ClientDTO>> {
    const response = await apiClient.get<PageResponse<ClientDTO>>(BASE_PATH, {
      params: { page, size, sort: 'createdAt' },
    });
    return response.data;
  }

  async getActiveClients(page: number = 0, size: number = 20): Promise<PageResponse<ClientDTO>> {
    const response = await apiClient.get<PageResponse<ClientDTO>>(`${BASE_PATH}/active`, {
      params: { page, size, sort: 'name' },
    });
    return response.data;
  }

  async updateClient(id: string, data: Partial<ClientDTO>): Promise<ClientDTO> {
    const response = await apiClient.put<ClientDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async deleteClient(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new ClientService();
